import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { SubscriptionItemPricingOverrideFormSchemaValues } from 'src/features/subscriptionItemPricingOverrides/utils/formSchema';
import { SubscriptionItemPricingOverride } from 'src/features/subscriptionItemPricingOverrides/utils/types';

const RESOURCE = '/subscriptions/subscription/:subscriptionId/subscription-item/:itemId/pricing-override/:overrideId/';

type MutationFnType = typeof mutationFn;

interface DTO extends SubscriptionItemPricingOverrideFormSchemaValues {
    subscriptionId: string;
    itemId: string;
    overrideId: string;
}

const mutationFn = ({ subscriptionId, itemId, overrideId, ...data }: DTO): Promise<SubscriptionItemPricingOverride> => {
    return axios.put(formatResourcePath(RESOURCE, { subscriptionId, itemId, overrideId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateSubscriptionItemPricingOverride };
